import { render, staticRenderFns } from "./medical-control.vue?vue&type=template&id=3d2fb86b&scoped=true"
import script from "./medical-control.vue?vue&type=script&lang=js"
export * from "./medical-control.vue?vue&type=script&lang=js"
import style0 from "./medical-control.vue?vue&type=style&index=0&id=3d2fb86b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2fb86b",
  null
  
)

export default component.exports